<div class="large-data-container" role="dialog" aria-labelledby="dialog-title" aria-modal="true">
      <h2 id="dialog-title" class="visually-hidden">Last Notice Special Notes</h2>
      <button mat-icon-button class="dialog-close-btn" (click)="close()" aria-label="Close dialog">×</button>
      <div class="content-wrapper" tabindex="0" role="document" aria-label="Scrollable content">
        <pre tabindex="0">{{data}}</pre>
      </div>
    </div>